<template>
    <div class="internal-management">
        <div class="breadcrumb">
            <i class="el-icon-arrow-left"></i>
            <el-breadcrumb separator-class="el-icon-arrow-left">
                <el-breadcrumb-item>内部管理</el-breadcrumb-item>
                <el-breadcrumb-item>内部账号管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="line"></div>
        <div class="table">
            <div class="add" v-if="getUserIdentity == 1">
                <el-button @click="addClick" icon="el-icon-plus" type="primary">新建管理账号</el-button>
            </div>
            <el-table :header-cell-style="{color: '#222222'}" :cell-style="{color: '#222222'}"
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        prop="email"
                        label="账号">
                </el-table-column>
                <el-table-column
                        label="角色">
                    <template slot-scope="scope">
                        <span :key="i.rid" v-for="i in scope.row.rlist">{{ i.rname }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="姓名">
                </el-table-column>
                <el-table-column
                        prop="memo"
                        label="角色描述">
                    <template slot-scope="scope">
                        <span>{{(scope.row.rlist[0] && scope.row.rlist[0].rname) | roleMemo(roleList) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        label="注册时间">
                </el-table-column>
                <el-table-column
                        v-if="getUserIdentity == 1"
                        label="操作">
                    <template slot-scope="scope">
                        <span @click="delClick(scope.row)" class="del">删除</span>
                        <span @click="editClick(scope.row)" class="edit">编辑</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
              <Pagination
                :total="total"
                :pageSize="pageSize"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
                :currentPage="currentPage"
              ></Pagination>
                <!-- <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="10"
                        layout="prev, pager, next, jumper"
                        :total="total">
                </el-pagination> -->
            </div>
        </div>
        <el-dialog :append-to-body="true" :title="activeUser ? '编辑账号' : '新建管理账号'" width="500px" :visible.sync="addDialogVisible">
            <el-form style="padding:0 20px;" ref="accountForm" :rules="rules" label-width="100px" :model="form">
                <el-form-item v-if="activeUser" prop="name" label="账号名称：">
                    <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="roleType" label="角色类型：">
                    <el-select style="width: 100%;" v-model="form.roleType" placeholder="请选择角色类型">
                        <el-option :key="item.rid" v-for="(item) in roleList" :label="item.name" :value="item.rid"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="!activeUser" prop="name" label="姓名：">
                    <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="email" label="登录邮箱：">
                    <el-input v-model="form.email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="!activeUser" prop="password" label="登录密码：">
                    <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="activeUser" prop="newPassword" label="登录密码：">
                    <el-input type="password" v-model="form.newPassword" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :disabled="adding" round type="primary" @click="addAccount">确 定</el-button>
                <el-button round @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true"
                title="提示"
                :visible.sync="deldialogVisible"
                width="30%">
            <p style="text-align: center;line-height: 60px">你确定删除该账号么？</p>
            <span slot="footer" class="dialog-footer">
                <el-button :disabled="clicked" round type="primary" @click="delUser">确 定</el-button>
                <el-button round @click="deldialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Api from '@/api'
import { statusCode } from '@/config'
import { sm3 } from '@/utils/sm3'
import { setStorageItem, getStorageItem, removeStorageItem } from '@/utils'
import Pagination from '@/components/common/Pagination.vue'

export default {
  name: 'accountManagement',
  components: {
    Pagination,
  },
  data() {
    const checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      const reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
      if (reg.test(value)) {
        return callback()
      }
      return callback(new Error('邮箱格式不正确'))
    }
    const checkName = (rule, value, callback) => {
      const reg = /^[a-zA-Z\u4e00-\u9fa5]+$/
      if (reg.test(value)) {
        return callback()
      }
      return callback(new Error('姓名格式不正确'))
    }
    const checkEditPwd = (rule, value, callback) => {
      if (this.oldEmail === this.form.email) {
        if (!value) {
          return callback()
        }
        const reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,16}$/
        if (reg.test(value)) {
          return callback()
        }
        return callback(new Error('8-16位，必须包含数字及字母，大小写均可，支持特殊字符'))
      }
      const reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,16}$/
      if (reg.test(value)) {
        return callback()
      }
      return callback(new Error('8-16位，必须包含数字及字母，大小写均可，支持特殊字符'))
    }
    const checkAddPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('密码不能为空'))
      }
      const reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,16}$/
      if (reg.test(value)) {
        return callback()
      }
      return callback(new Error('8-16位，必须包含数字及字母，大小写均可，支持特殊字符'))
    }
    return {
      tableData: [],
      currentPage: 1,
      clicked: false,
      total: 0,
      pageSize: 10, // 每页显示条数
      addDialogVisible: false,
      deldialogVisible: false,
      adding: false,
      activeUser: null,
      roleList: [],
      oldEmail: '',
      form: {
        roleType: '',
        name: '',
        email: '',
        password: ''
      },
      rules: {
        roleType: [
          { required: true, message: '请选择角色类型', trigger: 'change' },
        ],
        name: [
          { required: true, validator: checkName, trigger: 'blur' },
        ],
        email: [
          { required: true, validator: checkEmail, trigger: 'blur' },
        ],
        password: [
          { required: true, validator: checkAddPwd, trigger: 'blur' },
        ],
        newPassword: [
          { required: false, validator: checkEditPwd, trigger: 'blur' },
        ],
      }
    }
  },
  created() {
    this.getRoleList()
    this.getUserList()
  },
  filters: {
    roleMemo(val, roleList) {
      let roleMemo = ''
      for (let i = 0; i < roleList.length; i++) {
        if (val === roleList[i].name) {
          roleMemo = roleList[i].memo
          break
        }
      }
      return roleMemo
    }
  },
  computed: {
    getUserIdentity() {
      return getStorageItem('loginInfo').roleID
    },
  },
  methods: {
    addClick() {
      this.addDialogVisible = true
      this.form.roleType = ''
      this.form.name = ''
      this.form.email = ''
      this.form.password = ''
      this.form.newPassword = ''
      this.activeUser = null
      // this.$nextTick(() => {
      //   this.$refs.accountForm.resetFields()
      // })
    },
    handleSizeChange(val) {
      console.log("val123", val)
      this.pageSize = val
       console.log("val123this.pageSize", this.pageSize)
      this.getUserList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getUserList()
    },
    getRoleList() {
      const req = {
        pageParam: {
          count: this.pageSize,
          start: this.currentPage
        }
      }
      Api.user.roleList(req).then((res) => {
        if (res.retCode === statusCode.SUCCESS) {
          this.roleList = res.detail

          // 临时添加运维的角色
          // const yunweiRole = {
          //                  "rid":5,
          //                  "name":"系统运维",
          //                  "memo":"运维",
          //                  "plist":[{"pid":5,"pname":"系统运维权限"}]
          //                 }
          // this.roleList.push(yunweiRole)                
        } else {
          this.$message.closeAll()
          this.$message({
            showClose: true,
            message: res.retMsg,
            type: 'error'
          })
        }
      }).catch(() => {
      })
    },
    getUserList() {
      const req = {
        pageParam: {
          count: this.pageSize,
          start: this.currentPage
        }
      }
      Api.user.userList(req).then((res) => {
        if (res.retCode === statusCode.SUCCESS) {
          this.tableData = res.detail
          this.total = res.total
        } else {
          this.$message.closeAll()
          this.$message({
            showClose: true,
            message: res.retMsg,
            type: 'error'
          })
        }
      }).catch(() => {
      })
    },
    loginOut() {
      Api.user.loginOut().then((res) => {
        if (res.retCode === statusCode.SUCCESS) {
          this.$message({
            showClose: true,
            message: '请重新登录',
            type: 'success',
            duration: 500,
            onClose: () => {
              this.$router.push({
                name: 'login'
              })
            }
          })
        } else {
          this.$message({
            showClose: true,
            message: res.retMsg,
            type: 'error'
          })
        }
      }).catch(() => {
      })
    },
    addAccount() { // 添加或修改指定账号
      this.$refs.accountForm.validate((valid) => {
        if (valid) {
          this.adding = true
          const req = {
            name: this.form.name,
            rids: [this.form.roleType]
          }
          if (this.activeUser) {
            req.uid = this.activeUser.uid
            if (this.form.newPassword) {
              req.newpwd = sm3(this.form.newPassword)
            }
          }
          if (this.form.email !== this.oldEmail) {
            req.email = this.form.email
          }
          if (this.form.password) {
            req.pwd = sm3(this.form.password)
          }
          const formType = this.activeUser ? 'editUser' : 'addUser'
          Api.user[formType](req).then((res) => {
            if (res.retCode === statusCode.SUCCESS) {
              this.$message({
                showClose: true,
                message: this.activeUser ? '修改成功' : '添加成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                }
              })
              this.addDialogVisible = false
              this.currentPage = 1
              if (this.activeUser && (this.activeUser.uid === getStorageItem('loginInfo').uid) && this.form.newPassword) { // 当前修改密码账号为当前登录账号时注销登录
                this.loginOut()
              } else {
                this.getUserList()
              }
            } else {
              this.$message.closeAll()
              this.$message({
                showClose: true,
                message: res.retMsg,
                type: 'error'
              })
            }
            this.adding = false
          }).catch(() => {
            this.adding = false
          })
        } else {
          return false
        }
      })
    },
    cancel() {
      this.addDialogVisible = false
      this.activeUser = null
    },
    delClick(data) {
      this.activeUser = data
      this.deldialogVisible = true
    },
    delUser() {
      const req = {
        uid: this.activeUser.uid
      }
      this.clicked = true
      Api.user.delUser(req).then((res) => {
        if (res.retCode === statusCode.SUCCESS) {
          this.deldialogVisible = false
          this.$message({
            showClose: true,
            message: '已删除',
            type: 'success',
            duration: 1000,
          })
          this.currentPage = 1
          if (this.activeUser.uid === getStorageItem('loginInfo').uid) { // 当前删除账号为当前登录账号时注销登录
            this.loginOut()
          } else {
            this.getUserList()
          }
        } else {
          this.$message.closeAll()
          this.$message({
            showClose: true,
            message: res.retMsg,
            type: 'error'
          })
        }
        this.clicked = false
      }).catch(() => {
        this.clicked = false
      })
    },
    editClick(data) {
      this.activeUser = data
      this.oldEmail = data.email
      this.form = {
        roleType: data.rlist[0].rid,
        name: data.name,
        email: data.email,
        password: ''
      }
      this.addDialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
    .internal-management{
        width: 100%;
        min-height: calc(100vh - 110px);
        background-color: #ffffff;
        .line{
            width: 100%;
            height: 10px;
            background-color: #F7F7F7;
        }
        .breadcrumb{
            display: flex;
            height: 50px;
            background-color: #ffffff;
            line-height: 50px;
            padding-left: 15px;
            i{
                line-height: 50px;
                margin-left: 15px;
            }
            .el-breadcrumb{
                line-height: 50px;
            }
        }
        .table{
            margin-top: 10px;
            .add{
                height: 70px;
                background-color: #ffffff;
                width: 100%;
                .el-button{
                    margin-top: 20px;
                    float: right;
                    margin-right: 30px;
                }
            }
            .el-table{
                padding: 30px;
                padding-bottom: 0;
                /deep/ .del{
                    cursor: pointer;
                    color: #EB0000;
                }
                /deep/ .edit{
                    cursor: pointer;
                    color: #1E4499;
                    margin-left: 10px;
                }
            }
        }
        .el-dialog__wrapper{
            .el-select{
                width: 100%;
            }
            .dialog-footer{
                margin-top: -20px;
                text-align: center;
                .el-button{
                    width: 134px;
                }
            }
            /deep/ .el-dialog__footer{
                text-align: center;
            }
        }
    }
</style>
